import React from 'react'
import { Container, Row, Tab, Tabs } from 'react-bootstrap';
import styles from '../Measures/Measures.module.scss';
import { data } from '../data';

const NewsEmail = () => {

    return (<>

        <Container className='outerContainer'>
            <h3>Email Updates</h3>
            <p>Sign up for email updates to stay informed about modifications and enhancements to the Quality Indicators and other information related to the AHRQ Quality Indicators. By signing up, you will be notified by email when AHRQ announces the availability of new Quality Indicators, revisions to the software and related tools, as well as publications, reports and other related news.</p>
            <div className="flex">
                <div className="mr-5 pr-5"><img className="envelope mr-3 pr-3" src="/images/envelope-regular-black.png"/></div>
                <div className="p-2 pt-0 pb-0"><a href="https://subscriptions.ahrq.gov/accounts/USAHRQ/subscriber/new?topic_id=USAHRQ_39">Sign Up: Quality Indicators email updates</a></div>
            </div>
        </Container>
    </>)
}


export default NewsEmail;